'use client'

import Link from '@/components/navigation/LoadingLink'
import Script from 'next/script'
import { useEffect, useRef, useState, type ReactNode } from 'react'

export function ConsentLegalLinks({ children, adsenseSrc }: { children: ReactNode; adsenseSrc: string }) {
  const [isConsentPending, setIsConsentPending] = useState(true)
  const barRef = useRef<HTMLElement>(null)

  useEffect(() => {
    window.googlefc = window.googlefc ?? { callbackQueue: [] }
    window.googlefc.callbackQueue.push({
      CONSENT_DATA_READY: () => setIsConsentPending(false),
    })
  }, [])

  // Lets fixed overlays (e.g. the filter panel) leave room for the legal bar.
  useEffect(() => {
    const root = document.documentElement
    root.style.setProperty('--legal-bar-h', `${isConsentPending ? (barRef.current?.offsetHeight || 36) : 0}px`)
    return () => {
      root.style.removeProperty('--legal-bar-h')
    }
  }, [isConsentPending])

  return (
    <>
      <Script
        async
        src={adsenseSrc}
        crossOrigin="anonymous"
        strategy="afterInteractive"
        onError={() => setIsConsentPending(false)}
      />
      {isConsentPending ? (
        <>
          <div aria-hidden="true" className="h-9 shrink-0" data-testid="consent-legal-spacer" />
          <nav
            ref={barRef}
            aria-label="Rechtliche Hinweise"
            className="fixed bottom-0 left-0 right-0 z-[2147483647] flex justify-center gap-4 border-t border-ink bg-paper px-4 py-2 font-mono text-xs text-ink"
          >
            <Link href="/impressum" className="underline underline-offset-2 hover:bg-ink hover:text-paper">
              Impressum
            </Link>
            <Link href="/datenschutz" className="underline underline-offset-2 hover:bg-ink hover:text-paper">
              Datenschutz
            </Link>
          </nav>
        </>
      ) : (
        children
      )}
    </>
  )
}
